import ConditionalContainer from '.';
import CondDesignTool from "./DesignTool";

/** @type {UICore.ComponentMeta} */
const ConditionalContainerComponentMeta = {
  id: 'conditionalContainer',
  name: '条件容器',
  component: ConditionalContainer,
  category: '布局',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-condition-container_1636363450657.png',
  slots(layout) {
    return [...layout.props.branches.map(x => ({
      id: `branch-${x.id}`,
      containerRef: `branch-${x.id}`
    })), {
      // 兜底分支
      id: 'branch-0',
      containerRef: 'branch-0'
    }];
  },
  designerFlags: {
    allowAdjustWidth: false,
    // Row 的 designTool 会接管
    allowAdjustHeight: false
  },
  designTool: CondDesignTool,
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'branches',
      title: '条件分支',
      type: 'array',
      items: {
        type: 'object',
        fields: [{
          id: 'id',
          hidden: true,
          default: {
            $expr: '~~(Math.random() * 1e6)'
          }
        }, {
          id: 'expr',
          title: '条件表达式',
          type: 'string',
          ui: {
            type: 'exprInput'
          },
          default: '1 + 1 === 2'
        }, {
          id: 'name',
          title: '备注(可选)',
          type: 'string'
        }]
      }
    }, {
      id: 'showMulti',
      title: '展示全部分支',
      description: '勾选后，在设计模式下会展示全部分支',
      type: 'boolean',
      default: false
    }, {
      id: 'keepAlive',
      title: '组件保活',
      description: '勾选后，在运行模式下，组件被隐藏后不会被销毁',
      type: 'boolean',
      default: false
    }, {
      id: 'keepAliveMode',
      title: '保活模式',
      type: 'string',
      default: 'lazy',
      enum: [{
        value: 'lazy',
        label: '懒加载'
      }, {
        value: 'all',
        label: '一次性全部加载'
      }],
      condition: 'props.keepAlive'
    }]
  },
  initialLayout: {
    props: {
      showMulti: true
    }
  },
  getActions({
    instance,
    designer,
    layout
  }) {
    var _instance$branches, _layout$props;
    const {
      forceBranchIndex
    } = instance;
    const branchCount = instance.branches.length;
    const currentBranchName = `${forceBranchIndex >= branchCount ? '兜底分支' : `分支 #${forceBranchIndex + 1}: ${((_instance$branches = instance.branches) === null || _instance$branches === void 0 || (_instance$branches = _instance$branches[forceBranchIndex]) === null || _instance$branches === void 0 ? void 0 : _instance$branches.name) || '无备注'}`}`;
    const branchMenu = getCondContainerBranchMenu(instance);
    const res = !((_layout$props = layout.props) !== null && _layout$props !== void 0 && _layout$props.showMulti) ? [{
      title: '前一分支',
      icon: 'fa fa-caret-left',
      place: ['propPanel'],
      execute() {
        instance.goPrevBranch();
      }
    }, {
      title: '后一分支',
      icon: 'fa fa-caret-right',
      place: ['propPanel'],
      execute() {
        instance.goNextBranch();
      }
    }, {
      title: '---',
      place: ['propPanel', 'contextMenu']
    }, {
      title: `[ 当前: ${currentBranchName} ]`,
      place: ['propPanel', 'actionBar'],
      execute() {
        const target = document.activeElement;
        const {
          left: clientX,
          top: clientY
        } = target.getBoundingClientRect();
        designer.openContextMenu({
          clientX,
          clientY
        }, [{
          title: '选择分支',
          items: branchMenu
        }]);
        // designer.openContextMenuForActiveComp({ clientX: left, clientY: top, target });
      }
    }] : [];
    return [...res, ...branchMenu];
  },
  placeCompInside(ctx) {
    const getLayout = content => {
      const layoutContainer = {
        type: this.id,
        props: {
          showMulti: true,
          branches: [{
            expr: '1 + 1 === 2',
            id: 123456,
            name: ''
          }]
        },
        slots: {
          'branch-123456': content
        }
      };
      return layoutContainer;
    };
    return {
      name: this.name,
      /** 组件图标  */
      icon: this.icon,
      getLayout
    };
  }
};
export function getCondContainerBranchMenu(instance) {
  const {
    forceBranchIndex
  } = instance;
  const branchCount = instance.branches.length;
  return [...instance.branches.map((branch, idx) => ({
    title: `分支#${idx + 1}: ${branch.name || '(无备注)'}`,
    place: ['contextMenu'],
    highlighted: forceBranchIndex === idx,
    checked: forceBranchIndex === idx,
    execute() {
      // eslint-disable-next-line no-param-reassign
      instance.forceBranchIndex = idx;
    }
  })), {
    title: '兜底分支',
    place: ['contextMenu'],
    highlighted: forceBranchIndex >= branchCount,
    checked: forceBranchIndex >= branchCount,
    execute() {
      // eslint-disable-next-line no-param-reassign
      instance.forceBranchIndex = branchCount;
    }
  }];
}
export default ConditionalContainerComponentMeta;
//# sourceMappingURL=meta.js.map
